export default "__VITE_ASSET__be784e05__"